// prettier-ignore
import { anyone } from './access_defs';
import buildGqlQuery from './buildGqlQuery';

const vars = { id: 'ID!' };
const program = buildGqlQuery('reports_program', vars, 'acl:programGroupById(id: $id){ reportAccess }');
const district = buildGqlQuery('reports_district_whole', vars, 'acl:districtById(id: $id){ reportAccess }');
const district_districtSchools = buildGqlQuery('reports_district_districtSchools', vars, `districtById(id: $id){ districtSchools{ id } }`);
const district_nonDistrictSchools = buildGqlQuery('reports_district_nonDistrictSchools', vars, `districtById(id: $id){ districtSchools{ id } }`);
const school = buildGqlQuery('reports_school', vars, 'acl:schoolById(id: $id){ reportAccess }');
const klass = buildGqlQuery('reports_class', vars, 'classById(id: $id){ id }');
const user = buildGqlQuery('reports_user', vars, 'userById(id: $id){ id }');

export default {
	'reports': anyone,
	'reports/search': anyone,

	'reports/program/leaderboards': program,
	'reports/program/overview': program,
	'reports/program/proficiency': program,
	'reports/program/growth': program,
	'reports/program/community': program,

	'reports/district/leaderboards': district,
	'reports/district/overview': district,
	'reports/district/growth': district_districtSchools,
	'reports/district/proficiency': district_districtSchools,
	'reports/district/community': district_nonDistrictSchools,
	'reports/district/community-details': district_nonDistrictSchools,
	'reports/district/unassigned': district_nonDistrictSchools,

	'reports/class/activities': klass,
	'reports/class/attendance': klass,
	'reports/class/assignments-gradebook': klass,
	'reports/class/shared-links': klass,
	'reports/class/proficiency': klass,
	'reports/class/groups': klass,
	'reports/class/growth': klass,
	'reports/class/overview': klass,
	'reports/class/usage': klass,
	'reports/class/writing': klass,

	'reports/school/growth': school,
	'reports/school/leaderboard': school,
	'reports/school/proficiency': school,
	'reports/school/overview': school,
	'reports/school/unassigned': school,

	'reports/student/activity-log': user,
	'reports/student/assessment_wc-preview': user,
	'reports/student/assignments': user,
	'reports/student/shared-links': user,
	'reports/student/growth': user,
	'reports/student/overview': user,
	'reports/student/reading-log': user,
	'reports/student/usage': user,
	'reports/student/writing-log': user,
	'reports/student/proficiency': user,
	'reports/student/writing_wc-preview': user,

	'reports/user/overview': user,
};
